@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import 'node_modules/@gaiads/telia-react-component-library/build/styles/zindex';
@import '../../breakpoints';

$main-container-height: 72px;

.search {
  & ::-moz-focus-inner {
    border: 0;
  }

  &_inputWrapper {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    min-width: 0;
    width: 48px;
    background-color: color(white);
    margin-right: -8px;

    @include from('md') {
      transition: width 0.2s, min-width 0.2s;
    }

    &__active {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0;
      min-width: 310px;
      width: 100%;
      padding: 0 13px 0 15px;
      z-index: z(masked);
      height: $main-container-height;

      @include from('md') {
        position: relative;
        display: block;
        border-radius: 999px;
        padding: 0 40px;
        width: 310px;
        height: auto;
      }
    }
  }

  &_icon {
    cursor: pointer;
    background-color: white;
    left: 8px;
    position: absolute;
    top: 1px; // To fix IE position bug
    line-height: 0;

    & > svg {
      box-sizing: content-box;
      padding: 12px;
    }

    &:focus {
      outline-offset: -8px;
      outline: solid 4px color(blue500);
    }

    .search_inputWrapper__active & {
      position: relative;
      top: 0;
      left: 0;

      & > svg {
        padding: 5px;
      }

      &:focus {
        outline-offset: -1px;
        outline: solid 4px color(blue500);
      }

      @include from('md') {
        position: absolute;
        top: 7px;
        left: 10px;
      }
    }
  }

  &_closeIcon {
    cursor: pointer;
    padding: 0;
    top: 2px;
    right: 6px;
    position: absolute;
    background-color: transparent;
    z-index: z(deep);

    &:focus {
      outline-offset: -6px;
      outline: solid 4px color(blue500);
    }

    .search_inputWrapper__active & {
      position: relative;
      top: 0;
      right: 0;

      @include from('md') {
        position: absolute;
        top: 7px;
        right: 10px;
      }
    }
  }

  &_input {
    box-sizing: border-box;
    width: 100%;
    background-color: transparent;
    border: none;
    font-size: 16px;
    padding: 8px;
    outline: none;

    .search_inputWrapper__active & {
      height: 45px;
    }
  }

  &_overlay {
    background-color: rgba(color(black), 0.25);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
    transition: opacity 0.2s, height 0s ease-out 0.2s;
    opacity: 0;
    z-index: z(masked);

    @include from('md') {
      z-index: z(default);
    }

    &__visible {
      opacity: 1;
      height: 100%;
      transition: opacity 0.2s, height 0s;
    }
  }
}
